export const StatusBadge = ({ status }) => {
  let badgeClass = ''
  switch (status.toLowerCase()) {
    case 'active':
      badgeClass = 'bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300'
      break
    case 'closed':
      badgeClass = 'bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300'
      break
    default:
      badgeClass = 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300'
  }
  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${badgeClass}`}
    >
      {status}
    </span>
  )
}
